import { c as _c } from "react/compiler-runtime";
import React, { FC } from "react";
import TextHighlight from "../TextHighlight";
interface TitleProps {
  as?: React.ElementType;
  children?: string | null;
  className?: string;
  inverted?: boolean;
  serifClass?: string;
}
const Title: FC<TitleProps> = t0 => {
  const $ = _c(6);
  const {
    children,
    as,
    className: t1,
    inverted,
    serifClass
  } = t0;
  const className = t1 === undefined ? "text-d3" : t1;
  const t2 = as ?? "h2";
  let t3;
  if ($[0] !== children || $[1] !== className || $[2] !== inverted || $[3] !== serifClass || $[4] !== t2) {
    t3 = <TextHighlight as={t2} className={className} inverted={inverted} serifClass={serifClass} serif={true}>{children}</TextHighlight>;
    $[0] = children;
    $[1] = className;
    $[2] = inverted;
    $[3] = serifClass;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default Title;